import React from "react"
import Project from "./ProjectComponent"

class ProjectsComponent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            projects: []
        }
    }

    componentDidMount(){
        const { projects } = this.props
        // console.log(projects)
        // projects.sort((a, b) => {
        //     const stickyA = Boolean(a.sticky);
        //     const stickyB = Boolean(b.sticky);
        //     //console.log(stickyA, stickyB)
            
        //     return stickyB - stickyA
        // })
        //console.log(projects.edges[0].node.data)
        this.setState({
            projects: projects
        })
    }

    render() {
        //const { projects } = this.props
        const { projects } = this.state
        if(projects.length === 0)return(null)

        // console.log(projects)
        // const liste = projects.map((project, i) => {
        //     return <Project key={i} project={project}></Project>
        // })

        return (
            <div className="projects-component">
                <ul>
                    {projects.map((project, i) => (
                        <Project key={i} project={project}></Project>
                    ))}
                </ul>
            </div>
        )
    }
}

ProjectsComponent.displayName = "ProjectsComponent"

// Uncomment properties you need
// ProjectsComponent.propTypes = {};
// ProjectsComponent.defaultProps = {};

export default ProjectsComponent



// WEBPACK FOOTER //
// ./src/components/ProjectsComponent.js